// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#calendarAddLink{margin-top:15px;background-size:0}`, "",{"version":3,"sources":["webpack://./browser/theme/src/dipftheme/fullcalendar.scss"],"names":[],"mappings":"AAAA,iBACE,eAAA,CACA,iBAAA","sourcesContent":["#calendarAddLink {\n  margin-top: 15px;\n  background-size: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
